import React from 'react'
import InfoIcon from "../../../../styles/img/svg/InfoIcon"
import HeartIcon from "../../../../styles/img/svg/HeartIcon"
import EntryRightIcon from '../../../../styles/img/svg/EntryRightIcon';
import PropTypes from 'prop-types';

export function UiSalesChainElementWr(props) {

    return (
        <>
            <div className='sb-sales-chain'>
                <ul>
                    {props.children}
                </ul>
            </div>

        </>
    )
}

export function UiSalesChainElement(props) {

    return (
        <>
            <li className={props.isActive ? 'sb-sales-active' : '' || props.isEntryActive? 'sb-sales-active-entry' : ''}>
                <div className='sb-sales-chain__icon'>
                    {props.isActive ?
                        <HeartIcon /> : !props.isEntryActive && <InfoIcon />
                    }
                    {props.isEntryActive &&
                        <EntryRightIcon/> 
                    }
                </div>
                <div className='sb-sales-chain__content'>
                    <div className='sb-sales-chain__left'>
                        <label>{props.salesStatus}</label>
                        <span><span className='sb-sales-chain__id-text'>ID</span>{props.salesId}</span>
                    </div>
                    <div className='sb-sales-chain__right'>
                        <div className='sb-sales-chain__date'>{props.date}</div>
                    </div>
                </div>
            </li>

        </>
    )
}


export function UiSalesChainElementNoBgWr(props) {

    return (
        <>
            <div className='sb-sales-chain sb-sales-chain-no-bg'>
                <ul>
                    {props.children}
                </ul>
            </div>

        </>
    )
}

UiSalesChainElement.propTypes = {
    isActive: PropTypes.bool,
    salesStatus: PropTypes.string,
    salesId: PropTypes.string,
    date: PropTypes.string
};